module.exports = {
  "id": "gem",
  "title": "gem",
  "image": "provision/parts/gem/gem.png",
  "info": [
    {
      "text": "Add a gem to your project",
      "image": "provision/parts/gem/gem.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/gem/gem.png"
} ;